import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTranslation } from 'react-i18next';

import { downloadStudy } from '../../../util/downloadUtils';

export const DownloadDialog = ({ open, onClose, onSubmit: submitDownload = downloadStudy, studyInstanceUID, config }) => {
  const { t } = useTranslation();
  const [includeDicomdir, setIncludeDicomdir] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    if (!open) setProgress(null);
  }, [open]);

  const onSubmit = async () => {
    setDisabled(true);
    setProgress(0);
    try {
      await submitDownload({
        studyInstanceUID,
        includeDicomdir,
        config,
        onDownloadProgress: (event) => {
          setProgress(event.total ? Math.round((event.loaded * 100) / event.total) : null);
        },
      });
      onClose();
    } catch (error) {
      console.error('Unable to download study:', error);
    } finally {
      setDisabled(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="download-dialog-title"
      maxWidth={false}
      PaperProps={{
        style: {
          width: 500,
          maxWidth: 'calc(100% - 24px)',
          minHeight: 150,
          left: '50%',
          margin: 0,
          position: 'fixed',
          top: 75,
          transform: 'translate(-50%, 0)',
          fontSize: '1.3175rem',
          textAlign: 'center',
          color: '#dfe5ea',
          backgroundColor: '#111C',
          border: '1px solid #9FA5AABF',
        },
      }}
    >
      <DialogContent id="download-dialog-title">
        <FormControlLabel
          control={(
            <Checkbox
              checked={includeDicomdir}
              onChange={(event) => setIncludeDicomdir(event.target.checked)}
              color="primary"
            />
          )}
          label={t('include.dicomdir')}
        />
        <LinearProgress
          variant={progress === null ? 'indeterminate' : 'determinate'}
          value={progress === null ? undefined : progress}
          style={{
            margin: '8px auto 0',
            maxWidth: 400,
            visibility: disabled ? 'visible' : 'hidden',
            width: '100%',
          }}
        />
        {disabled && progress !== null && (
          <div>
            {progress}
            %
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={onSubmit}
          style={{
            backgroundColor: '#132630',
            border: '1px solid #324b5a',
            color: '#eef3f5',
          }}
        >
          {t('download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadDialog;
